module.exports = "./assets/images/avatar-4.svg";